<template lang="pug">
div
  template(v-if="!showMobile")
    topbar
    .conbox
      .hometabs
        tabList
  .tabbox
    .gbox-wrap.overflow-hidden
      .news-list-wrap.text-white
        .news-listbox
          .iimg
            img(src="assets/img/article/article_9.jpg")
            a.btn-submit.btn-custom.text-white(v-if="!$store.getters.isLoggedIn" href='javascript:void(0);' @click="$helpers.openModal('#regModal')") Signup Now
          .ccon
            h1 Cash In on Fun: Your Guide to the Best Online Casino Philippines
            p Welcome to the thrilling world of online casino Philippines, where you can experience the excitement of traditional casinos from the comfort of your own home. The popularity of online casinos has surged in recent years, offering a convenient and entertaining way to enjoy your favorite games. Whether you're a seasoned player or new to the scene, the online casino Philippines scene has something for everyone. From the convenience of accessing a wide range of games to the potential for big wins, the online casino experience in the Philippines is truly unparalleled.
            h3 Exploring JILI Games in the Philippines
            p JILI Games has emerged as a prominent player in the online casino industry, offering a wide array of engaging and innovative games for players in the Philippines. With a focus on cutting-edge technology and captivating gameplay, JILI Games has garnered a dedicated following among online casino enthusiasts. From visually stunning slots to interactive live dealer games, JILI Games continues to push the boundaries of online casino entertainment in the Philippines.
            h3 Overview of Pagcor Online Casino Certification
            p PAGCOR-licensed online casinos offer a comprehensive gaming experience, combining the thrill of traditional casinos with the convenience of online accessibility. These platforms adhere to strict regulatory standards set by PAGCOR, ensuring that players can enjoy a safe and secure gaming environment. Additionally, PAGCOR online casino certification often feature a diverse range of games, lucrative bonuses, and reliable customer support, making them a top choice for players seeking a premium gaming experience.
            h3 Leveraging Slot Free 100 Offers in Online Casinos
            p Slot Free 100 offers are a popular promotion among online casinos in the Philippines, providing players with an opportunity to kickstart their gaming journey with complimentary credits. These offers typically come in the form of free spins or bonus funds, allowing players to explore various slot games without risking their own funds. By leveraging Slot Free 100 offers, players can familiarize themselves with different slot titles and potentially win real money without making an initial deposit.
            h3 Casino Plus Free 100 PHP Casino: Benefits and Considerations
            p The free 100 PHP casino promotions are designed to enhance the overall gaming experience for players in the Philippines. Whether it's bonus funds, free spins, or a combination of both, these promotions offer tangible benefits that can amplify the excitement and potential rewards of online casino gaming. However, it's essential for players to carefully review the terms and conditions associated with these offers, including wagering requirements and game restrictions, to make informed decisions about utilizing Casino Plus Free 100 promotions.
            h3 Tips for Maximizing Free 100 Upon Registration Casino
            p When taking advantage of casino offers upon registration, it's important to approach these promotions strategically to maximize their potential benefits. One effective strategy involves exploring a diverse range of games to spread the complimentary funds or spins across different titles, increasing the chances of discovering new favorites and potentially winning big. Additionally, staying informed about the expiration dates and specific usage guidelines for the free 100 upon registration casino offer can help players make the most of this valuable opportunity.
</template>
<script>
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import tabList from '@/views/default/_tabs.vue'
export default {
  components:{
    topbar,
    tabList
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
			loading:false,
      showMobile: false,
    }
  },
  created(){
    window.scroll(0,0)
		this.getSeo("cash-in-on-fun-your-guide-to-the-best-online-casino-philippines")
		this.checkSize()
    var vm = this
    $(window).resize(function () {
      vm.checkSize()
    });
	},
  methods:{
    getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
  }
}
</script>